import { render, staticRenderFns } from "./InterviewResult.vue?vue&type=template&id=330d1b40&scoped=true"
import script from "./InterviewResult.vue?vue&type=script&lang=js"
export * from "./InterviewResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "330d1b40",
  null
  
)

export default component.exports